import React, { useLayoutEffect } from "react";
import HanshiLogo from '../../assets/hanshi/full-lg.svg';
import Style from "./Logo.module.css";

const Logo = (props) => {
    const { cssClass, logo } = props;

    return (
        <div className="d-flex justify-content-center">
            <img src={(logo ? logo.url : HanshiLogo) || HanshiLogo} alt="" className={`${cssClass} ${Style.logo}`} />
        </div>
        
    );
};

export default Logo;